//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    projectName: {
      type: String,
      default: '',
    },
  },
}
